// Boshqaruv amallarining natijasi — UCH HOLATLI, boolean EMAS.
// (CLAUDE.md §3.2 Qoida 4, §8; 07-FRONTEND.md §10)
//
// Sabab arxitekturaviy: baza "qanday bo'lishi kerak"ni saqlaydi, NAS'dagi
// faol sessiya esa "hozir qanday"ni. CoA/Disconnect ikkalasini moslashtirish
// URINISHI, kafolat emas. Ya'ni tabiiy holatlar uchtta:
//
//   OK      — baza yangilandi VA faol sessiyaga qo'llandi
//   PARTIAL — baza yangilandi, lekin faol sessiyaga qo'llanmadi
//   FAILED  — baza ham yangilanmadi (haqiqiy xato)
//
// ⚠️ `PARTIAL` — XATO EMAS, OGOHLANTIRISH. Backend uni HTTP 200 bilan
// qaytaradi. Uni xatoga aylantirish ham, "muvaffaqiyatli" deb ko'rsatish ham
// noto'g'ri: birinchisi operatorni bekor qilishga undaydi (baza esa to'g'ri),
// ikkinchisi esa YOLG'ON — abonent hali ham eski tezlikda ishlayapti.

import { z } from 'zod'

export const OPERATION_STATUSES = ['OK', 'PARTIAL', 'FAILED'] as const
export type OperationStatus = (typeof OPERATION_STATUSES)[number]

export const operationResultSchema = z.object({
  status: z.enum(OPERATION_STATUSES),
  /** Foydalanuvchiga ko'rsatiladigan matn — serverdan keladi */
  message: z.string(),
  /** Texnik tafsilot: CoA javobi, xato kodi. Yig'ilgan holda ko'rsatiladi. */
  detail: z.string().nullish(),
})

export interface OperationResult {
  status: OperationStatus
  message: string
  detail?: string | null
}

export function isOk(result: OperationResult): boolean {
  return result.status === 'OK'
}

/** Baza to'g'ri, lekin faol sessiyaga yetib bormadi */
export function isPartial(result: OperationResult): boolean {
  return result.status === 'PARTIAL'
}

/**
 * Amal DAVOM ETDIMI — ya'ni baza o'zgardimi.
 *
 * `OK` va `PARTIAL` ikkalasida ham baza yangilangan, demak ro'yxatni qayta
 * so'rash kerak. Faqat `status === 'OK'` ni tekshirish keng tarqalgan xato:
 * `PARTIAL` da ekrandagi ma'lumot eskirgan holda qolib ketadi.
 */
export function didChangeState(result: OperationResult): boolean {
  return result.status !== 'FAILED'
}
